import React, { useEffect, useMemo, useState, useRef } from 'react';
import useHeader from '../../hooks/useHeader';
import { useDispatch } from 'react-redux';
import {
  exploreMenuRequest,
  getRestaurantDetails,
  getRestaurantMenuDetails,
  setSelectedDeliveryType,
} from '../../common/features/restaurant/restaurantAction';
import {
  cartItemRequest,
  isScheduleOrderPlaceOrder,
  replacecartItems,
  routeToLogin,
  setNotip,
  setSelectedDate,
  setTipAdded,
  toggleCartView,
} from '../../common/features/cart/cartActions';
// import accountsBack from "../../common/assets/svg/accountsBack.svg";
import Logouticon from '../../common/assets/svg/mdi_logout.svg';
// import calendar from "../../common/assets/svg/HeaderCalender.svg";
// import map from "../../common/assets/svg/header-map-pin.svg";
// import { ReactComponent as CartIcon } from "../../common/assets/svg/cartIcon.svg";
import userIcon from '../../common/assets/svg/profile-user.svg';
import checkOutBell from '../../common/assets/svg/checkOutBell.svg';
import { ReactComponent as CheckOutBell } from '../../common/assets/svg/checkOutBell.svg';
import { ReactComponent as UserIcon } from '../../common/assets/svg/profile-user.svg';
import { ReactComponent as ActiveUser } from './../../common/assets/svg/activeUser.svg';
import { ReactComponent as BackBtn } from '../../common/assets/svg/Backbtn.svg';
import { ReactComponent as HomeIcon } from '../../common/assets/svg/homePage.svg';
import backBtnWhite from '../../common/assets/svg/Back.svg';
import { useLocation, useNavigate, useParams } from 'react-router';
import Signupnew from '../Signupnew/Signupnew';
import SwitchingorderType from '../SwitchingorderType/SwitchingorderType';
import { useSelector } from 'react-redux';
import { RestaurantMenuItem } from '../../common/features/restaurant/restaurantModels';
import { ORDER_STATUS_CODES, USER_DETAILS, USER_ID } from '../../common/constants';
import { clearGetOrderDetail } from '../../common/features/order/orderActions';
import { Helmet } from 'react-helmet-async';
import useRedirect from '../../hooks/useRedirct';
import { getCookie } from '../../helper/cookieHelper';
import { setSignupPopup as setSignupPopupAction } from '../../common/features/navigation/navigationActions';

const MobileHeader = ({
  setPaymentStatus,
  setSignupPopup,
  setCardDelete,
  signupPopup,
  Switch,
  currentOrdertypeDetails,
  setCurrentOrdertypeDetails,
  menuType,
  handleBack,
  Logoutfn,
  NavigateProfile,
  GotoProfile,
  isMobile,
  isAccountPage,
  selectedTab,
  setIsSearchActive,
  setShowMenuDrawer,
  notShowuserIcon,
  notShowBack,
  notshowHomeIcon,
}: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
    const redirect=useRedirect()
  const userName =( getCookie(USER_DETAILS) || {})?.firstName || '';
  const { merchantType, merchantSlug, tableId } = useParams();
  const slugDetails = useSelector((state: any) => state.persistedState.persistedRestaurantDetails);
  const isEventDate = useSelector((state: any) => state.cart.isEventDate);
  const eventDate = useSelector((state: any) => state.cart.eventDate);
  const storeTableId = useSelector((state: any) => state.persistedState.tableId)
  const dineInTableId = storeTableId;



  const { orderTraking } = location.state || {};
  const cartItems = useSelector((state: any) => state?.cart?.cart?.items);

  const commonSuccess = (menuItems: RestaurantMenuItem[]) => {
    const menuItemMap = new Map(menuItems.map(item => [item.itemId, item]));

    const updatedCartItems = cartItems.map((cartItem: any) => {
      const matchedMenuItem = menuItemMap.get(cartItem.itemId);
      if (!matchedMenuItem) return cartItem;

      const validOptionIds = new Set(
        (matchedMenuItem.customization || []).map((opt: any) => opt.modifierOptionId)
      );

      const filteredOptions = (cartItem.options || []).filter((opt: any) =>
        validOptionIds.has(opt.modifierOptionId)
      );

      const optionTotal = filteredOptions.reduce((sum: number, opt: any) => {
        return sum + (typeof opt.price === 'number' ? opt.price : 0);
      }, 0);

      const newPrice = parseFloat(matchedMenuItem.price);
      const quantity = parseFloat(cartItem.quantity);
      const newSubTotal = ((newPrice + optionTotal) * quantity).toFixed(2);

      return {
        ...cartItem,
        price: newPrice,
        subTotal: newSubTotal,
        options: filteredOptions,
      };
    });

    dispatch(replacecartItems(updatedCartItems));
  };

  const {
    isCart,
    goBack,
    getImageURL,
    restaurantDetails,
    selectedDeliveryType,
    setCartItem,
    CartItemIds,
    basePath,
    setSwitchingOrderType,
    // tableId,
    orderDetails,
    orderInfo,
    handleLogoutclick,
    cdOrdersItems,
    showLogout,
    setShowLogout,
    switchingOrderType,
    cartData,
  } = useHeader({ handleBack, currentOrdertypeDetails, menuType, setCurrentOrdertypeDetails });
  
  const slugFromLocalStorage = localStorage.getItem('restaurant') && JSON.parse(localStorage.getItem('restaurant') || '');

  const isDineInOrder = restaurantDetails?.orderTypes?.some(
    (type: any) => type?.typeGroup === 'D' && type?.typeName === menuType
  );
 const {menuType:menuTypeParams} = useParams<any>()
  const isOrderCompleteOrCancel = useMemo(() => {
    if (orderDetails) {
      return (
        orderDetails.status == ORDER_STATUS_CODES.ORDER_PICKED_UP ||
        orderDetails.status == ORDER_STATUS_CODES.ORDER_COMPLETE ||
        orderDetails.status == ORDER_STATUS_CODES.ORDER_CANCELLED_MERCHANT ||
        orderDetails.status == ORDER_STATUS_CODES.ORDER_CANCELLED_CUSTOMER
      );
    } else {
      return false;
    }
  }, [orderDetails]);

console.log({orderTraking});

    
  const [shouldNotShowBackbtn, setShouldNotShowBackbtn] = useState(false);
  const globalShowSignupPopup = useSelector((state: any) => state?.navigation?.showSignupPopup);
  const [isGlobalTriggered, setIsGlobalTriggered] = useState(false);
  const prevGlobalStateRef = useRef(false);

  // Listen to global Redux state for 403/401 errors
  useEffect(() => {
    // Only mark as globally triggered if state changes from false to true (new 403/401)
    if (globalShowSignupPopup && !prevGlobalStateRef.current) {
      setIsGlobalTriggered(true);
      // Also set local popup state when globally triggered
      if (setSignupPopup) {
        setSignupPopup(true);
      }
    } else if (!globalShowSignupPopup) {
      // When global state becomes false, reset the flag
      setIsGlobalTriggered(false);
      if (setSignupPopup) {
        setSignupPopup(false);
      }
    }
    prevGlobalStateRef.current = globalShowSignupPopup;
  }, [globalShowSignupPopup, setSignupPopup]);

  useEffect(() => {
    const pathname = location.pathname;
    const endsWithPrivacyPolicy = pathname.endsWith('PrivacyPolicy');
    const includesAccountOrPolicies = pathname.includes('account') || pathname.includes('policies');

    if (endsWithPrivacyPolicy && !includesAccountOrPolicies) {
      setShouldNotShowBackbtn(true);
    }
  }, [location.pathname]);

  const customerId = getCookie(USER_ID) || '';
  const currentUserDetail = useSelector((state: any) => state.user.currentUserDetail)

  const PickupOrderType = restaurantDetails?.orderTypes?.filter(
    (item: any) => item.typeGroup === 'P'
  );
  const DeliveryOrderType = restaurantDetails?.orderTypes?.filter(
    (item: any) => item.typeGroup === 'S'
  );
  const BothOrderTypeisnotAvailble =
    PickupOrderType &&
    !PickupOrderType[0]?.isEnabled &&
    DeliveryOrderType &&
    !DeliveryOrderType[0]?.isEnabled;

  const checkinTableId = localStorage.getItem('CHECKIN_TABLE_ID');
 

  const handleToggelSwitch = (type: string) => {
    dispatch(getRestaurantDetails(merchantSlug as any));
    dispatch(setSelectedDeliveryType(type));
    dispatch(isScheduleOrderPlaceOrder(false))
    setCartItem(true);
    setIsSearchActive&&setIsSearchActive(false);
    if(menuType?.toLowerCase() !== type?.toLowerCase()){
      dispatch(setNotip(""))
      dispatch(setTipAdded(false))
    }
    navigate(`${basePath}/${type}`);
    let payload = {
      type,
      locationId: restaurantDetails.id,
      customerId: customerId,
      searchText: null,
      visibleTo: "C",
      sagaSuccessCB: commonSuccess
    };
 
    dispatch(getRestaurantMenuDetails(payload));
    const currentPickUpOrderTypeId =
      restaurantDetails?.orderTypes?.find(
        (o: any) => o?.typeName === "Pickup"
      )?.id;

    const currentDeliveryOrderTypeId =
      restaurantDetails?.orderTypes?.find(
        (o: any) => o?.typeGroup === "S"
      )?.id;

    const cartItemObj = cartData?.map((item: any) => ({
      itemId: item?.itemId,
      modifierIds: item?.options?.map((modifier: any) => modifier?.typeId)
    }))

  const cartPayload = {
      itemIds: CartItemIds,
      itemObj: cartItemObj,
      orderTypeId: type==='Pickup' ? currentPickUpOrderTypeId : currentDeliveryOrderTypeId,
      locationId: restaurantDetails?.id
    };

    dispatch(cartItemRequest(cartPayload));
  }
  const [dishes, setDishes] = useState<RestaurantMenuItem[]>([]);
  
  const exploreMenu = useSelector(
    (state: any) => state.restaurant.exploreMenu?.menu
  );

  useEffect(() => {
    if (exploreMenu && exploreMenu?.length > 0) {
      setDishes([...exploreMenu]);
    }
  }, [exploreMenu]);

  useEffect(() => {
    if (!exploreMenu && isMobile && restaurantDetails?.id && dishes?.length < 1 && menuType) {
      dispatch(
        exploreMenuRequest({
          locationId: restaurantDetails?.id,
          menuType: menuType,
        })
      );
    }
  }, [restaurantDetails.id, menuType, slugFromLocalStorage?.location]);

  const isExploretabActive = useSelector((state: any) => state.restaurant.isExploretabActive)
 const acceptedLinksForIcon = location?.pathname?.includes('/account/DeliveryAddress') || location?.pathname?.includes('/account/Cards') ||
  location?.pathname?.includes('/account/MyOrders') || location?.pathname?.includes('/account/FAQ') || location?.pathname?.includes('/account/Favorites') ;

  return (
    <div
      className={`menu-page-header-new ${isDineInOrder && !dineInTableId ? 'dine-in-header' : ''}`}
    >
    <Helmet>
        <title>{restaurantDetails?.seo?.metaTitle}</title>
        <meta name="description" content={restaurantDetails?.seo?.metaDescription} />
        <meta name="keywords" content={restaurantDetails?.seo?.metaKeywords} />
        <meta name="robots" content={restaurantDetails?.seo?.metaTags} />
        <meta name="canonical" content={restaurantDetails?.seo?.metaCanonical} />
        <meta name="author" content={restaurantDetails?.seo?.metaAuthor} />
        <meta name="image" content={restaurantDetails?.seo?.metaImage} />
      </Helmet>
      {
        <div>
          {!shouldNotShowBackbtn && (
            <>
              {isAccountPage ||
                (isCart && !menuType) ||
                (isDineInOrder && dineInTableId && location?.pathname?.includes('/order')) ||
                (location?.pathname?.includes('/feedbacks') && !dineInTableId) ||
                (location?.pathname?.includes('/placeOrder/payment') && !dineInTableId) ||
                location?.pathname?.includes('/order') ||
                (location?.pathname?.includes('/tracker') && !dineInTableId) ||
                (location?.pathname?.includes('/account') && !dineInTableId && !dineInTableId) ? (
                  <div className='Backbtn-new' 
                   
                  >
                      <BackBtn
                  className="homePageIcon-new"
                  style={{ width: '37px', height: '37px' }}
                  onClick={() => {
                    if (isDineInOrder) {
                      navigate(
                        `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${dineInTableId}/menu/${slugFromLocalStorage?.menuType}/contactlessdinein/landing`
                      );
                    } else if (setPaymentStatus) {
                      setPaymentStatus(true);
                    } else if (isOrderCompleteOrCancel && checkinTableId) {
                      localStorage.removeItem('CDUSER');
                      localStorage.removeItem('ACTIVE_ORDERS');
                      dispatch(clearGetOrderDetail());
                      if(isExploretabActive){
                        navigate(
                          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${checkinTableId}/menu/${slugFromLocalStorage?.menuType}/exploremenu`
                        );
                      }else{
                        navigate(
                          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${checkinTableId}/menu/${slugFromLocalStorage?.menuType}`
                        );
                      }
                    } else if (location.pathname?.includes('/CD/feedbacks')) {
                      navigate(
                        `/restaurant/${slugDetails?.location}/table/${dineInTableId}/menu/${slugDetails?.menuType}`
                      );
                    } 
                    else if (orderTraking) {
                      navigate(-1);
                    } 
                    else {
                      if(isMobile){
                        navigate(-1);

                      }
                      else{
                         navigate(
                        `/restaurant/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}`
                      );

                      }
                        
                      
                     
                       
                      // setTimeout(() => navigate(-1), 0);
                    }
                  }}
                 
                />

                  </div>
              
              ) : !isDineInOrder && !dineInTableId ? (
                <HomeIcon
                  className="homePageIcon-new"
                  style={{ width: '37px', height: '37px' }}
                  onClick={() => {
                    // setShowMenuDrawer(true);
                    navigate(`/${merchantType}/${merchantSlug}`);
                    if (setPaymentStatus) setPaymentStatus(true);
                  }}
                />
              ) : (
                <div className="homePageIcon-new"></div>
              )}
            </>
          )}
        </div>
      }

      <div
        className="restaurant-logo-container-new"
        style={{ marginLeft: shouldNotShowBackbtn ? '40px' : '' }}
      >
        {getImageURL('LOGO') && (
          <img
            src={getImageURL('LOGO')}
            alt="logo"
            className={
              isDineInOrder && !dineInTableId
                ? 'restaurant-logo-new-mobile-DineIn'
                : 'restaurant-logo-new-mobile'
            }
            title="Restaurant Logo"
          />
        )}
        {
          <span className="restaurant-branchName-new">
            {' '}
            {restaurantDetails.branchName?.split(',')[1]}, {restaurantDetails.state}
          </span>
        }
        {/* {(
          <span className="restaurant-branchName-new">
            {" "}
            {restaurantDetails.state}
          </span>
          
        )} */}
      </div>

      {Switch && (
        <>
          {
            <div className="toggle-container-new">
              <button
                className={` ${selectedDeliveryType === 'Pickup' ? 'active' : ''} 
                 ${BothOrderTypeisnotAvailble || (PickupOrderType && !PickupOrderType[0]?.isEnabled)
                    ? ''
                    : ''
                  } `}
                style={{
                  cursor: "pointer"
                  // PickupOrderType && PickupOrderType[0]?.isEnabled ? 'pointer' : 'default',
                }}
                disabled={isEventDate}
                onClick={() => {

                  handleToggelSwitch("Pickup")
                  dispatch(setSelectedDate(null))
                }}
              >
                {isEventDate
                  ? `${eventDate.replace(/-/g, ' ').charAt(0).toUpperCase()}${eventDate
                    .replace(/-/g, ' ')
                    .slice(1)} (Pickup)`
                  : 'Pickup'}
              </button>
              {isEventDate ? null : (
                <button
                  className={` ${selectedDeliveryType === 'Delivery' ? 'active' : ''}  ${BothOrderTypeisnotAvailble ||
                      (DeliveryOrderType && !DeliveryOrderType[0]?.isEnabled)
                      ? ''
                      : ''
                    } `}
                  style={{
                     cursor: "pointer"
                      // DeliveryOrderType && DeliveryOrderType[0]?.isEnabled ? 'pointer' : 'default',
                  }}
                  onClick={() => {
                    dispatch(setSelectedDeliveryType('Delivery'));
                      handleToggelSwitch("Delivery")
                      dispatch(setSelectedDate(null))
                  }}
                >
                  Delivery
                </button>
              )}
            </div>
          }
        </>
      )}

      {
        <div className={isMobile ? 'userIcon-container-mobile' : 'userIcon-container'}>
          {!acceptedLinksForIcon && !((location?.pathname?.includes('/account')) && !(location?.pathname?.includes('/Policies')) )&&
            !location?.pathname?.includes('/feedbacks') &&
            !shouldNotShowBackbtn && (
              <div>
                {
                  <div className="userIcon-container">
                    {
                    
                    (currentUserDetail?.firstName === '' || customerId) && dineInTableId ==="" && !isDineInOrder ? 

                    (
                      <div className="active-user-withname">
                        <ActiveUser onClick={handleLogoutclick} className="active-user-icon-new" />
                        {<p className={isMobile ? 'loginText' : 'loginText-D'}>{userName}</p>}
                      </div>
                    ) :
                    
                    (
                      <>
                        {(!isDineInOrder || dineInTableId) &&
                          (dineInTableId  && isMobile? (
                            <CheckOutBell
                              title="User Icon"
                              className="user-icon-new"
                              onClick={() => {
                                if (dineInTableId && orderDetails && orderInfo) {
                                  navigate(
                                    `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${dineInTableId}/order/${orderInfo[0]?.orderId}`
                                  );
                                }
                                if (!dineInTableId) {
                                  // When manually opening, reset global trigger flag first
                                  setIsGlobalTriggered(false);
                                  // Set local state first, then global state
                                  if (setSignupPopup) setSignupPopup(true);
                                  // Small delay to ensure local state is set before global
                                  setTimeout(() => {
                                    dispatch(setSignupPopupAction(true));
                                  }, 0);
                                }
                              }}
                            />
                          ) : (
                            !notShowuserIcon && (
                              <UserIcon
                                title="User Icon"
                                className="user-icon-new"
                                onClick={() => {
                                  if (dineInTableId && orderDetails) {
                                    navigate(
                                      `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${dineInTableId}/order/${orderInfo[0]?.orderId}`
                                    );
                                  }
                                  if (!dineInTableId) {
                                    // When manually opening, reset global trigger flag first
                                    setIsGlobalTriggered(false);
                                    // Set local state first, then global state
                                    if (setSignupPopup) setSignupPopup(true);
                                    // Small delay to ensure local state is set before global
                                    setTimeout(() => {
                                      dispatch(setSignupPopupAction(true));
                                    }, 0);
                                  }
                                }}
                              />
                            )
                          ))}

                        {!dineInTableId && !isDineInOrder && !notShowuserIcon && !(location?.pathname?.includes('/Policies')) &&(
                          <p className="loginText">{'Login'}</p>
                        )}
                        {cdOrdersItems?.length > 0 && (
                          <div className="CD-orderCount">{cdOrdersItems?.length}</div>
                        )}
                      </>
                    )}
                  </div>
                }
              </div>
            )}
        </div>
      }

      {customerId && showLogout && (
        <div
          className="Log-out-Container"
          onClick={() => {
            Logoutfn();
            setShowLogout(false);
          }}
        >
          <img src={Logouticon} alt="" />
          <span className="logout-text">Log out</span>
        </div>
      )}

      {/* Only show local Signupnew if it's manually triggered (not from global 403/401) */}
      {signupPopup && !isGlobalTriggered && (
        <Signupnew
          isOpen={signupPopup}
          onClose={() => {
            if (setSignupPopup) {
              setSignupPopup(false);
                dispatch(setSignupPopupAction(false));
              dispatch(routeToLogin(false));
            }
          }}
        />
      )}
      {switchingOrderType && cartData?.length > 0 && (
        <SwitchingorderType
          isOpen={switchingOrderType}
          onClose={() => {
            setSwitchingOrderType(false);
            if (basePath) {
              if (selectedDeliveryType === 'Pickup') {
                dispatch(setSelectedDeliveryType('Delivery'));
                navigate(`${basePath}/Delivery`);
              } else if (selectedDeliveryType === 'Delivery') {
                dispatch(setSelectedDeliveryType('Pickup'));
                navigate(`${basePath}/Pickup`);
              }
            }
          }}
          currentOrdertypeDetails={currentOrdertypeDetails}
        />
      )}
    </div>
  );
};

export default MobileHeader;
